import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { useParams, Link } from 'react-router-dom'
import { RootState } from '../../../states/containers/store'
import { setPath } from '../../../utils/url'
import { URL } from '../../constants/url'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import classNames from 'classnames'
import Tips from './Tips'

type LangValue = "ja" | "en"

interface Props {
  isOpen: boolean
  toggleCallback: VoidFunction
}

const SideBarSubSetting: FC<Props> = (props) => {
  const {
    isOpen,
    toggleCallback,
  } = props

  const {
    login,
  } = useSelector((state: RootState) => state)

  const { language } = useParams<{ language: LangValue }>()

  return (
    <>
      {
        location.pathname.match(URL.SETTING.path) ? (
          <div className="side_sub_wrap">
            <div className="setting">
              <div className="tools">
                <div className="setting_menu">
                  <button
                    type="button"
                    className={`setting_toggle ${isOpen && "display"}`}
                    onClick={() => toggleCallback()}
                  >
                    <div className={`menu ${isOpen && "active"}`}>
                      <FontAwesomeIcon icon={['fas', 'angle-double-left']} />
                    </div>
                  </button>
                </div>
              </div>
              <section className="side_sub">
                <div>
                  <div className="item folder">
                    <div className="name_label">
                      <div className="name_area">
                        操作
                      </div>
                    </div>
                  </div>
                  <Link
                    to={setPath(URL.SETTING_PERSONAL.path, language)}
                    className={classNames({
                      active: (
                        location.pathname.match(URL.SETTING_PERSONAL.path)
                        || location.pathname.match(URL.SETTING_PROFILE.path)
                        || location.pathname.match(URL.SETTING_CLIENT_DOWNLOAD.path)
                        || location.pathname.match(URL.SETTING_MFA_AUTH.path)
                        || location.pathname.match(URL.SETTING_OAUTH.path)
                        || location.pathname.match(URL.SETTING_MAIL_DELIVERY.path)
                        || location.pathname.match(URL.SETTING_INDIVIDUAL_MEASUREMENT.path)
                      ),
                      item: true,
                    })}
                  >
                    <div className="name_label">
                      <div className="name_area">
                        <FontAwesomeIcon
                          icon={['fas', 'user']}
                          className="icon task"
                        />
                        個人設定
                      </div>
                    </div>
                  </Link>
                  {
                    login.role_name ? (
                      <>
                        <Link
                          to={setPath(URL.SETTING_COMMON.path, language)}
                          className={classNames({
                            active: (
                              location.pathname.match(URL.SETTING_COMMON.path)
                              || location.pathname.match(URL.SETTING_MEMBER.path)
                              || location.pathname.match(URL.SETTING_MEMBER_DETAIL.path)
                              || location.pathname.match(URL.SETTING_TEAM.path)
                              || location.pathname.match(URL.SETTING_ADMIN.path)
                              || location.pathname.match(URL.SETTING_HOLIDAY_SCHEDULE.path)
                              || location.pathname.match(URL.SETTING_HOLIDAY.path)
                              || location.pathname.match(URL.SETTING_BASE_WORK_TIME.path)
                              || location.pathname.match(URL.SETTING_MEASUREMENT.path)
                              || location.pathname.match(URL.SETTING_MEASUREMENT_RESTRICTION.path)
                              || location.pathname.match(URL.SETTING_RECODE_API_CONNECT.path)
                              || location.pathname.match(URL.SETTING_WEB_BROWSER.path)
                              || location.pathname.match(URL.SETTING_IP_RESTRICTION.path)
                              || location.pathname.match(URL.SETTING_OFFICE_IP_ADDRESS.path)
                              || location.pathname.match(URL.SETTING_LANGUAGE.path)
                              || location.pathname.match(URL.SETTING_CONTRACT.path)
                              || location.pathname.match(URL.SETTING_IMPORT_CSV.path)
                              || location.pathname.match(URL.SETTING_TASK_PERMISSION.path)
                              || location.pathname.match(URL.SETTING_TASK_APPROVAL_SETTING.path)
                              || location.pathname.match(URL.SETTING_TASK_EXCLUDE_GENERATE_MEMBER_SETTING.path)
                              || location.pathname.match(URL.SETTING_TASK_THRESHOLD_TIME_SETTING.path)
                              || location.pathname.match(URL.SETTING_TASK_CREATE_MANUAL_TASK_ZONE_SETTING.path)
                              || location.pathname.match(URL.SETTING_TASK_CREATE_TASK_BY_URL_SETTING.path)
                              || location.pathname.match(URL.SETTING_TASK_LEARNING_SCOPE_SETTING.path)
                              || location.pathname.match(URL.SETTING_EXTERNAL_API_KEY.path)
                              || location.pathname.match(URL.SETTING_TASK_ONLINE_MEETING_SETTING.path)
                            ),
                            item: true,
                          })}
                        >
                          <div className="name_label">
                            <div className="name_area">
                              <FontAwesomeIcon
                                icon={['fas', 'users']}
                                className="icon task"
                              />
                              {`${login.role_name === "管理者" ? "管理者" : "共通"}設定`}
                            </div>
                          </div>
                        </Link>
                      </>
                    ) : (
                      <>
                        <Tips
                          description="いずれかのロール権限が付与された場合のみ操作できます"
                          className=""
                          icon={false}
                        >
                          <div className="item disable">
                            <div className="name_label">
                              <div className="name_area">
                                <FontAwesomeIcon
                                  icon={['fas', 'users']}
                                  className="icon task"
                                />
                                共通設定
                              </div>
                            </div>
                          </div>
                        </Tips>
                      </>
                    )
                  }
                  {
                    login.role_permission?.role_setting ? (
                      <>
                        <Link
                          to={setPath(URL.SETTING_ROLE.path, language)}
                          className={classNames({
                            active: (
                              location.pathname.match(URL.SETTING_ROLE.path)
                            ),
                            item: true,
                          })}
                        >
                          <div className="name_label">
                            <div className="name_area">
                              <FontAwesomeIcon
                                icon={['fas', 'cogs']}
                                className="icon task"
                              />
                              権限ロール設定
                            </div>
                          </div>
                        </Link>
                      </>
                    ) : (
                      <>
                        <Tips
                          description="権限ロール設定権限が付与された場合のみ操作できます"
                          className=""
                          icon={false}
                        >
                          <div className="item disable">
                            <div className="name_label">
                              <div className="name_area">
                                <FontAwesomeIcon
                                  icon={['fas', 'cogs']}
                                  className="icon task"
                                />
                                権限ロール設定
                              </div>
                            </div>
                          </div>
                        </Tips>
                      </>
                    )
                  }
                  {
                    login.role_permission?.custom_alert_setting ? (
                      <>
                        <Link
                          to={setPath(URL.SETTING_CUSTOM_ALERT.path, language)}
                          className={classNames({
                            active: location.pathname.match(URL.SETTING_CUSTOM_ALERT.path),
                            item: true,
                          })}
                        >
                          <div className="name_label">
                            <div className="name_area">
                              <FontAwesomeIcon
                                icon={['fas', 'bell']}
                                className="icon task"
                              />
                              アラート設定
                            </div>
                          </div>
                        </Link>
                      </>
                    ) : (
                      <>
                        <Tips
                          description="アラート設定権限が付与された場合のみ操作できます"
                          className=""
                          icon={false}
                        >
                          <div className="item disable">
                            <div className="name_label">
                              <div className="name_area">
                                <FontAwesomeIcon
                                  icon={['fas', 'bell']}
                                  className="icon task"
                                />
                                アラート設定
                              </div>
                            </div>
                          </div>
                        </Tips>
                      </>
                    )
                  }
                </div>
              </section>
            </div>
          </div>
        ) : (
          <></>
        )
      }
    </>
  )
}

export default SideBarSubSetting
